module.exports = __webpack_public_path__ + "static/media/bordered-shield.56c12b47.svg";